<template lang="pug">
el-form(ref='titleConsideration', :inline='true', :inline-message="true", validateOnRuleChange=false,
  :model='titleConsideration', :rules='rules', v-if="titleConsideration !== undefined"
  label-width='160px', size='small', :disabled='applicationFinalSaved')
  type-of-study(
    :fromConsideration="fromConsideration",
    :title="titleConsideration",
    @typeOfStudyChanged="fieldChanged"
  )
  title-details(
    :fromConsideration="fromConsideration",
    :title="titleConsideration",
    :countries="countries",
    :applicationFinalSaved="applicationFinalSaved"
    @titleDetailsChanged="fieldChanged"
  )
</template>

<script>
import sharedMethods from './sharedMethods.js'
import typeOfStudy from './typeOfStudy'
import titleDetails from './titleDetails'

export default {
  components: {
    typeOfStudy,
    titleDetails,
  },
  mixins: [sharedMethods],
  props: [
    'titleConsideration',
    'countries',
    'applicationFinalSaved',
    'checkFormTC',
    'consideration',
    'application',
  ],
  data() {
    return {
      fromConsideration: true,
      formValidation: false,
    }
  },
  computed: {
    rules() {
      if (this.formValidation) {
        return {
          // 'test': [{ required: (this.titleConsideration.partOfStudiesGr && this.consideration), message: 'Παρακαλώ', trigger: 'change', max: 100 }],
          cityOfStudiesGr: [
            {
              required:
                this.titleConsideration.partOfStudiesGr && this.consideration,
              message: this.$t('studyCityRequiredMsg'),
              trigger: 'change',
              max: 100,
            },
          ],
          institutionOfStudiesGr: [
            {
              required:
                this.titleConsideration.partOfStudiesGr && this.consideration,
              message: this.$t('institutionRequiredMsg'),
              trigger: 'change',
              max: 100,
            },
          ],
          'country.name': [
            {
              required: this.consideration,
              message: this.$t('studyCountryRequiredMsg'),
              trigger: 'change',
              max: 100,
            },
          ],
          'university.name': [
            {
              required: this.consideration,
              message: this.$t('universityRequiredMsg'),
              trigger: 'change',
              max: 255,
            },
          ],
          'university.universityInserted': [
            {
              required:
                this.consideration &&
                this.titleConsideration.university.name === 'other',
              message: this.$t('universityRequiredMsg'),
              trigger: 'change',
              max: 255,
            },
          ],
          certificationTitle: [
            {
              required: this.consideration,
              message: this.$t('titleRequiredMsg'),
              trigger: 'change',
              max: 200,
            },
          ],
          credits: [
            {
              type: 'number',
              required: this.consideration,
              message: this.$t('ectsValidationMsg'),
              min: 0,
              max: 1000,
              trigger: 'change',
            },
          ],
          dateOfRegistration: [
            {
              required: this.consideration,
              message: this.$t('startDateRequiredMsg'),
              trigger: 'change',
              max: 100,
            },
          ],
          dateOfGraduation: [
            {
              required: this.consideration,
              message: this.$t('graduationDateRequiredMsg'),
              trigger: 'change',
              max: 100,
            },
          ],
          durationOfStudies: [
            {
              required: this.consideration,
              message: this.$t('durationRequiredMsg'),
              trigger: 'change',
              max: 100,
            },
          ],
        }
      } else {
        return null
      }
    },
  },
  methods: {
    checkForm() {
      this.$refs['titleConsideration'].validate(valid => {
        if (valid) {
          this.considerationValid = true
          this.$emit('considerationValidEvent', this.considerationValid)
        } else {
          this.considerationValid = false
          this.$emit('considerationValidEvent', this.considerationValid)
        }
      })
    },
    fieldChanged(val) {
      this.formValidation ? this.checkForm() : console.log('first visit') // this.$refs['titleConsideration'].clearValidate()
      this.$emit('titleConsiderationChanged', this.titleConsideration)
    },
  },
  watch: {
    checkFormTC: function(newData, oldData) {
      this.formValidation = true
      this.checkForm()
    },
  },
}
</script>

<style scoped lang="scss">
@import '../../styles/variables.scss';

.el-autocomplete {
  width: 440px;
}
.my-autocomplete {
  li {
    line-height: normal;
    padding: 3px;

    .value {
      text-overflow: clip;
      font-size: 9px;
      overflow: hidden;
      color: #6d728b;
      white-space: normal;
    }
    .link {
      text-overflow: clip;
      font-size: 10px;
      color: #33408a;
      white-space: normal;
    }
  }
}
// @media only screen and (min-width: $screen-sm-min) {
//   .maxSteps {
//     display: none;
//   }
// }
.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 190px;
}
.el-input {
  &.big {
    width: 440px;
  }
  &.biggest {
    width: 530px;
  }
}
.el-textarea {
  &.biggest {
    width: 530px;
  }
}
.el-select {
  &.big {
    width: 440px;
  }
  &.biggest {
    width: 1100px;
  }
  &.countries {
    width: 440px;
  }
}
.hideSMup {
  display: none;
}
.hideSMdown {
  display: block;
}
.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 180px;
}
.el-checkbox__input.is-disabled + span.el-checkbox__label {
  color: #1b91de;
}

@media only screen and (max-width: $screen-sm-min) {
  .hideSMup {
    display: block;
  }
  .hideSMdown {
    display: none;
  }
  .el-autocomplete {
    width: 240px;
  }
  .el-input {
    &.big {
      width: 240px;
    }
    &.biggest {
      width: 260px;
    }
  }
  .el-select {
    &.countries {
      width: 260px;
    }
    &.big {
      width: 260px;
    }
    &.biggest {
      width: 260px;
    }
  }
}
</style>
